import React, { useState, useEffect } from "react";
import { Menu, X, LogOut, LayoutDashboard, ChevronDown } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "./Logo";
import { useAuth } from "../context/AuthContext";
import ChangePasswordDialog from "./ChangePasswordDialog";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator,
} from "./ui/dropdown-menu";
import { KeyRound } from "lucide-react";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [pwOpen, setPwOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/first-season-artist-info");
  };

  const initials = user?.name?.trim()?.charAt(0)?.toUpperCase() || "U";

  const AuthArea = () => (
    user ? (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="flex items-center gap-2.5 rounded-full border border-white/12 bg-white/[0.05] py-1.5 pl-1.5 pr-3 hover:bg-white/[0.08] transition-colors">
            <span className="flex items-center justify-center rounded-full text-black font-bold text-sm" style={{ width: 30, height: 30, background: "#8cff00" }}>{initials}</span>
            <span className="text-white text-sm font-medium max-w-[120px] truncate">{user.name}</span>
            <ChevronDown size={15} className="text-white/50" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-[#0f0a17] border-white/10 text-white min-w-[200px]">
          <div className="px-2 py-1.5 text-xs text-white/45 truncate">{user.email}</div>
          <DropdownMenuSeparator className="bg-white/10" />
          {user.role === "admin" || user.role === "owner" ? (
            <DropdownMenuItem className="cursor-pointer focus:bg-white/10" onClick={() => navigate("/admin")}>
              <LayoutDashboard size={16} className="mr-2" style={{ color: "#8cff00" }} /> Admin Dashboard
            </DropdownMenuItem>
          ) : null}
          <DropdownMenuItem className="cursor-pointer focus:bg-white/10" onClick={() => setPwOpen(true)}>
            <KeyRound size={16} className="mr-2" /> Change password
          </DropdownMenuItem>
          <DropdownMenuItem className="cursor-pointer focus:bg-white/10" onClick={handleLogout}>
            <LogOut size={16} className="mr-2" /> Log out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    ) : (
      <Link to="/login" className="btn-purple">Sign In</Link>
    )
  );

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-black/85 backdrop-blur-md border-b border-white/5" : "bg-transparent"}`}>
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-[68px] flex items-center justify-between">
        <Link to="/first-season-artist-info" className="flex items-center gap-2.5">
          <Logo height={44} />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <AuthArea />
        </div>

        <button className="md:hidden text-white" onClick={() => setOpen((v) => !v)} aria-label="Toggle menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-[#0a0a0e]/98 backdrop-blur-md border-t border-white/5 px-6 py-5 flex flex-col gap-4">
          <div className="pt-2">{user ? (
            <div className="flex flex-col gap-3">
              {(user.role === "admin" || user.role === "owner") && <Link to="/admin" className="nav-link" onClick={() => setOpen(false)}>Admin Dashboard</Link>}
              <button onClick={() => { setOpen(false); setPwOpen(true); }} className="nav-link text-left">Change password</button>
              <button onClick={handleLogout} className="btn-green-outline w-full justify-center"><LogOut size={16} /> Log out</button>
            </div>
          ) : (<Link to="/login" className="btn-purple w-full justify-center" onClick={() => setOpen(false)}>Sign In</Link>)}</div>
        </div>
      )}
      <ChangePasswordDialog open={pwOpen} onOpenChange={setPwOpen} />
    </header>
  );
};

export default Navbar;
